export enum DrawWaiverType {
    OutOfBalanceWaiver = 1,
}
